/**
 * System age helpers (MRG-1008). We store the install/replacement year and
 * derive the age at display time so it never goes stale.
 */

/** Approximate age from a year, e.g. 2014 → "~12 yrs" */
export function formatSystemAge(year: number, currentYear = new Date().getFullYear()): string {
  const age = currentYear - year
  if (age < 1) return 'under 1 yr'
  return `~${age} ${age === 1 ? 'yr' : 'yrs'}`
}

/** Detail-page value for a year, e.g. "2014 · ~12 yrs", or "2001 · ~25 yrs · original" */
export function formatSystemYear(
  year: number,
  yearBuilt?: number | null,
  currentYear = new Date().getFullYear()
): string {
  const parts = [String(year), formatSystemAge(year, currentYear)]
  if (yearBuilt && year === yearBuilt) parts.push('original')
  return parts.join(' · ')
}
